export default __webpack_public_path__ + "static/media/logo.cb1b715a.png";